var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpandRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_443_6741)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 1.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#354ACD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 1.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#809FB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.177 13.1769L14.177 18.1769C14.1538 18.2001 14.1262 18.2185 14.0959 18.2311C14.0655 18.2437 14.033 18.2502 14.0001 18.2502C13.9673 18.2502 13.9348 18.2437 13.9044 18.2311C13.8741 18.2185 13.8465 18.2001 13.8233 18.1769C13.8 18.1537 13.7816 18.1261 13.769 18.0957C13.7565 18.0654 13.75 18.0329 13.75 18C13.75 17.9672 13.7565 17.9346 13.769 17.9043C13.7816 17.8739 13.8 17.8464 13.8233 17.8231L18.6464 13L13.8233 8.17689C13.7764 8.12998 13.75 8.06636 13.75 8.00002C13.75 7.93368 13.7764 7.87005 13.8233 7.82314C13.8702 7.77623 13.9338 7.74988 14.0001 7.74988C14.0665 7.74988 14.1301 7.77623 14.177 7.82314L19.177 12.8231C19.2003 12.8464 19.2187 12.8739 19.2313 12.9043C19.2439 12.9346 19.2503 12.9672 19.2503 13C19.2503 13.0329 19.2439 13.0654 19.2313 13.0958C19.2187 13.1261 19.2003 13.1537 19.177 13.1769Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_443_6741",
    x: -2,
    y: 0,
    width: 36,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_443_6741"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_443_6741",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpandRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/expandRight.c2f120712cd90898f0e2cb03f5f4eeba.svg";